import { X } from 'lucide-react';

import { cn } from '@/shared/utils/cn';

interface Props {
  className?: string;
  onClick?: () => void;
}

export function ModalCloseButton({ className, onClick }: Props) {
  return (
    <button onClick={onClick} className={cn(className)}>
      <X className="text-foreground size-5 opacity-70" />
    </button>
  );
}
